import { Box, styled } from '@mui/material';

const StyHeaderBudgetSettings = styled(Box, {
    name: 'StyHeader',
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '1rem',
});

export default StyHeaderBudgetSettings;
